import React from 'react';

function Loading() {
  return (
    <h1>LOADING...</h1>
  );
}

export default Loading;
